import React, { FC } from 'react';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';

const defaultToastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  pauseOnHover: true,
  closeOnClick: true,
  draggable: true,
  hideProgressBar: false,
  theme: 'colored',
};

export function emitNotification(message: React.ReactNode, options?: ToastOptions): void {
  toast(message, { ...defaultToastOptions, ...options });
}

export function emitSuccessNotification(message: React.ReactNode, options?: ToastOptions): void {
  toast.success(message, { ...defaultToastOptions, ...options });
}

export function emitWarningNotification(message: React.ReactNode, options?: ToastOptions): void {
  toast.warning(message, { ...defaultToastOptions, ...options });
}

export function emitErrorNotification(message: React.ReactNode, options?: ToastOptions): void {
  toast.error(message, { ...defaultToastOptions, ...options });
}


const Notification: FC = () => {
  return <ToastContainer {...defaultToastOptions} />;
};

export default Notification;
